/**
 * Is there anything worth printing?
 *
 * Lives in its own module so `orderFacts.jsx` exports components only — a file that mixes the two
 * breaks Vite's fast refresh (the same reason `pageTitles.js` was split out of `Layout.jsx`).
 *
 * "Empty" deliberately includes the strings the API and the old formatters use to mean nothing: a
 * literal "N/A" costs exactly as much reading time as a blank, which is what this is here to save.
 */
const EMPTY_TEXT = new Set(["", "-", "—", "n/a", "na", "null", "undefined"]);

export const hasValue = (value) => {
  if (value == null || value === false) return false;
  if (typeof value === "number") return true;
  if (typeof value === "string") {
    const text = value.trim();
    return text !== "" && !EMPTY_TEXT.has(text.toLowerCase());
  }
  if (Array.isArray(value)) return value.some(hasValue);
  return true;
};
